import {i18n} from '@/plugins/i18n'

export const documentFormat = {
    IMAGE: 0,
    PDF: 1
}

export const documentStatuses = {
    PENDING: 0,
    UPLOADED: 1 ,
    CHECK_BY_PSP: 2,
    CONFIRMED: 3,
    REJECTED: 4,
    UNCOMPLETED: 5
}
